import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  data: ResponseData;
  status: number;
  message: string;
};
type ResponseData = {
  response_object: any;
  total_records: number;
  start: number;
  length: number;
};

type PaymentToVendorBody = {
  body: {
    amount_pay: number;
    remark: string;
    date: string;
  };
  id: any;
};

type Body = {
  start: number;
  length: number;
  search: string;
};

export const paymentApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    vendorPaymentSummary: builder.query({
      query: (body) => ({
        url: `${END_POINTS.paymentSummary}`,
        method: "POST",
        body,
      }),
    }),
    pamentToVendor: builder.mutation<
      CommonResponseType & { data: any },
      PaymentToVendorBody
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.paymentToVendor}${id}/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useLazyVendorPaymentSummaryQuery, usePamentToVendorMutation } =
  paymentApi;
